import React from 'react'
import * as Sentry from '@sentry/react'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, info) {
    Sentry.captureException(error, {
      extra: {
        componentStack: info.componentStack,
      },
    })
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback || (
          <div style={{ padding: '24px', textAlign: 'center' }}>
            <h2>Something went wrong.</h2>
            <p>Please refresh the page. If the problem persists, contact support.</p>
          </div>
        )
      )
    }
    return this.props.children
  }
}

export default ErrorBoundary
